export default __webpack_public_path__ + "static/media/e45725debd2e5157cd09da2f07eb40ec1579890990412.c9af466d.webp";